import { CustomErrorType } from "../../constants/action-types";
import { SuccessDTO } from "../../constants/dto/success";
import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { BASE_METHODS } from "../../constants/enum";
import { timeoutError } from "../../constants/reducer/base-reducer";
import { setExchangeRateErrorMessage } from "../../constants/reducer/exchange-rate-reducer";
import {
  removeDocument,
  setDocumentActionStart,
  setDocumentErrorMessage,
} from "../../constants/reducer/document-reducer";

type DeleteDocumentProps = {
  id: number;
};
let body: SuccessDTO;
export const deleteDocument = async (props: DeleteDocumentProps) => {
  store.dispatch(setDocumentActionStart(true));

  await createCall(
    `cms/documents/${props.id}`,
    BASE_METHODS.DELETE,
    "application/json",
    undefined,
    undefined
  )
    .then(async (response) => {
      try {
        body = plainToClass(SuccessDTO, JSON.parse(await response.text()));
      } catch (error) {
        console.log(error);
        return;
      }
      if ((await validate(body)).length > 0) {
        store.dispatch(
          setExchangeRateErrorMessage("delete-exchange-rate-invalid-response")
        );
        return;
      }

      store.dispatch(removeDocument(props.id));
    })
    .catch((error) => {
      const errorResponeData: CustomErrorType = error;
      if (errorResponeData) {
        let errorMessage = "";
        switch (errorResponeData.code) {
          case 3002:
            errorMessage = "delete-exchange-rate-data-not-found-error-message";
            break;
          default:
            break;
        }
        store.dispatch(setDocumentErrorMessage(errorMessage));
        return;
      }
      store.dispatch(setDocumentActionStart(false));
      store.dispatch(timeoutError());
    });
};
